import type { ManagedUser } from '@/domain/model/ManagedUser';
import type { TotpSetup, UpdateMeCommand, ChangePasswordCommand } from '@/domain/model/MeAccount';
import type { MeGateway } from '@/application/port/out/MeGateway';
import type {
  GetMeUseCase, UpdateMeUseCase, ChangePasswordUseCase,
  SetupTotpUseCase, EnableTotpUseCase, DisableTotpUseCase,
} from '@/application/port/in/MeUseCase';

export class GetMe implements GetMeUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(): Promise<ManagedUser> { return this.g.getMe(); }
}
export class UpdateMe implements UpdateMeUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(cmd: UpdateMeCommand): Promise<ManagedUser> { return this.g.updateMe(cmd); }
}
export class ChangePassword implements ChangePasswordUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(cmd: ChangePasswordCommand): Promise<void> { return this.g.changePassword(cmd); }
}
export class SetupTotp implements SetupTotpUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(): Promise<TotpSetup> { return this.g.setupTotp(); }
}
export class EnableTotp implements EnableTotpUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(code: string): Promise<void> { return this.g.enableTotp(code); }
}
export class DisableTotp implements DisableTotpUseCase {
  constructor(private readonly g: MeGateway) {}
  execute(currentPassword: string, code: string): Promise<void> { return this.g.disableTotp(currentPassword, code); }
}
